// Copyright (c) 2021, Comsearch, Inc., All rights reserved

const getUsedBandCountsFromPaths = paths => (
  paths.reduce((a, d) => {
    // default the band value to null
    const bandId = d?.get?.('bandId') || d.bandId || null

    // if we've already stored this band, add to its count
    if (a[bandId]) {
      ++a[bandId]
      // otherwise add it to the hash and set its count to 1.
    } else {
      a[bandId] = 1
    }
    return a
  }, {}) // defaulting this value makes it easier to handle when all paths have bands assigned.
)

export default getUsedBandCountsFromPaths
